"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PieChart = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.5,2 C16.7467051,2 21,6.25329488 21,11.5 C21,16.7467051 16.7467051,21 11.5,21 C6.25329488,21 2,16.7467051 2,11.5 C2,6.25329488 6.25329488,2 11.5,2 Z M3,11.5 C3,16.0267505 6.53858773,19.7270195 11.0005248,19.9855686 L11.0005248,3.01443136 C6.53858773,3.27298054 3,6.97324955 3,11.5 Z M19.9855108,12.0004728 L12,12 L12.0004728,19.9855108 C16.2086722,19.7411732 19.5953287,16.4354118 19.9662733,12.2623957 L19.9855108,12.0004728 Z M12.0004728,3.01448923 L12,11 L19.9855686,11.0005248 C19.7366153,6.70418951 16.2966755,3.26393647 12.0004728,3.01448923 Z" })));
};
PieChart.displayName = 'PieChart';
exports.default = PieChart;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PieChart.js.map